export const logsDetailsGet = (data) => {
    return data.data
}
export const logsDetailsFilterGet = (data) => {
    return data.data
}
export const logDetailsById = (data) => {
    return data.data
}
